import React, {useState} from 'react';

import styles from './DeliveryByCompanies.module.css'
import {Company} from "../../../../../../types/Delivery.interface.ts";
import {DeliveryShippingAddress} from "./components/DeliveryShippingAddress/DeliveryShippingAddress.tsx";
import {useScreenDetector} from "../../../../../../hooks/useScreenDetector.ts";
import {Button} from "../../../../../../ui/General/Button/Button.tsx";
import {Order} from "../../../../../../types/Order.interface.ts";
import {logo} from "../../../../../../assets/icons/icons.ts";
import {cn} from "../../../../../../utils/cn.ts";
import { API_URL } from '../../../../../../config.tsx';

interface Props {
    offer: Order,
}
interface TransportCompanyOfferProps {
    offer: Company,
    orderId: number,
}

const DesktopTransportCompanyOffer: React.FC<TransportCompanyOfferProps> = ({orderId, offer}) => {
    const {name, alias} = offer;
    const [duration, setDuration] = useState('');
    const [price, setPrice] = useState('');

    const getData = () => {
        fetch(`${API_URL}/order/${orderId}/transport_company_delivery_data?transportCompanyAlias=${alias}`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(data => {
                if(data) {
                    setDuration(data.duration);
                    setPrice(data.price);
                }
            })
    }

    return <div className={styles.company}>
        <div className={styles.companyInfo}>
            <img className={styles.logo} src={logo} alt={name}/>
            <div>{name}</div>
        </div>
        {
            ([
                'sdek_door_door',
                'sdek_door_door_air',
                'rf_mail_first_class',
                'rf_mail_package_online',
                'rf_mail_package_standart',
                'ems',
                'rf_mail_courier_online',
            ]).includes(alias)
                ? (
                    duration && price
                    ? <>
                            <div>{Number(price) / 100} ₽</div>
                            <div>{duration} дн.</div>
                        </>
                        : <Button
                        className={cn(styles.btn, styles.btnNewOffers)}
                        type='regular'
                        onClick={() => getData()}
                        style={{maxWidth: 250,}}
                    >
                        Получить данные
                    </Button>
                )
                : <div>Уточнит менеджер при подтверждении заказа</div>
        }
    </div>
}
export const DeliveryByCompanies: React.FC<Props> = ({
                                                         offer,
                                                     }) => {
    const {isMobile, isDesktop} = useScreenDetector();

    return (<>
        {isDesktop && (<>
            <h3 className={styles.title}>Выберите компанию</h3>
            <div className={styles.table}>
                <div className={styles.header}>
                    <div>Способ доставки</div>
                    <div>Стоимость доставки</div>
                    <div>Сроки доставки</div>
                </div>
                <div className={styles.content}>
                    {
                        offer.delivery.company
                        ? <DesktopTransportCompanyOffer
                                key={offer.delivery.company.id}
                                offer={offer.delivery.company}
                                orderId={offer.orderId}
                            />
                        : null
                    }
                    <div className={styles.address}>
                        <div className={styles.outline}/>
                        <DeliveryShippingAddress
                            offer={offer}
                        />
                    </div>
                </div>
            </div>
        </>)}

        {isMobile && (<>
            <div className={styles.wrapper}>
                <div className={styles.settings}>
                    <h4>Выберите компанию</h4>
                    <Button type='text'>
                        Изменить
                    </Button>
                </div>
                <ul className={styles.offers}>
                    {
                        offer.delivery.company
                        ? <li className={styles.offer}>
                            <div>{offer.delivery.company.name}</div>
                            <div className={styles.price}>Уточнит менеджер при подтверждении заказа</div>
                            <div className={styles.date}>Уточнит менеджер при подтверждении заказа</div>
                            <div className={styles.outline}/>
                        </li>
                        : null
                    }
                </ul>
            </div>
            <div className={styles.address}>
                <DeliveryShippingAddress
                    offer={offer}
                />
            </div>
        </>)}
    </>);
};
